// extracted by mini-css-extract-plugin
export default {"container":"Otp_container__CRuVN","form":"Otp_form__HN-o3"};